import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "@/resources/requestInfo";
import { IGame, ICreateGameData, IApplyGameData } from "./types";

export const fetchGetGamesList = createAsyncThunk<IGame[], void>(
  "games/fetchGetGamesList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/games");
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Ошибка получения списка игр"
      );
    }
  }
);

export const fetchGetAppliedGames = createAsyncThunk<IGame[], void>(
  "games/fetchGetAppliedGames",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/games/applications");
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Ошибка получения игр с заявками"
      );
    }
  }
);

export const fetchGetCreatedGames = createAsyncThunk<IGame[], void>(
  "games/fetchGetCreatedGames",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/games/my");
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Ошибка получения созданных игр"
      );
    }
  }
);

export const fetchGetApplicationsCount = createAsyncThunk<
  { count: number },
  void
>("games/fetchGetApplicationsCount", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get("/games/my/applications-count");
    return response.data;
  } catch (error: any) {
    return rejectWithValue(
      error.response?.data?.message ||
        "Ошибка получения количества заявок"
    );
  }
});

export const fetchGetGameById = createAsyncThunk<IGame, number>(
  "games/fetchGetGameById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/games/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Ошибка получения игры"
      );
    }
  }
);

export const fetchCreateGame = createAsyncThunk<IGame, ICreateGameData>(
  "games/fetchCreateGame",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/games", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Ошибка создания игры"
      );
    }
  }
);

export const fetchApplyGame = createAsyncThunk<IGame, { id: number; data: IApplyGameData }>(
  "games/fetchApplyGame",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/games/${id}/apply`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Ошибка подачи заявки на игру"
      );
    }
  }
);

export const fetchDeleteGame = createAsyncThunk<number, number>(
  "games/fetchDeleteGame",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/games/${id}`);
      return id;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Ошибка удаления игры"
      );
    }
  }
);

export const fetchCancelApplication = createAsyncThunk<number, number>(
  "games/fetchCancelApplication",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/games/${id}/cancel-application`);
      return id;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Ошибка отмены заявки"
      );
    }
  }
);

export const fetchMarkApplicationsAsSeen = createAsyncThunk<
  void,
  { applicationIds: number[] }
>("games/fetchMarkApplicationsAsSeen", async (data, { rejectWithValue }) => {
  try {
    await axiosInstance.post("/games/applications/mark-seen", data);
  } catch (error: any) {
    return rejectWithValue(
      error.response?.data?.message ||
        "Ошибка отметки заявок как просмотренных"
    );
  }
});
